import { FC, PropsWithChildren } from "react";

import { Global } from "@emotion/react";
import { ComponentsThemeProvider } from "@hl/base-components/lib/theme/provider";
import { useAccountSettings } from "@hl/shared-features/lib/features/auth/hooks/useAccountSettings";

import fonts from "../fonts";

const GlobalStyles = () => (
  <Global
    styles={(theme) => ({
      ":root": {
        "--scrollbar-color": theme.colors.baseBackground[0],
        "--scrollbar-thumb-color": theme.colors.divider[0],
        // This causes the page to be scrollable even when a
        // mantine modal is open - is this needed?
        // overflowY: "scroll",
      },
      ".infinite-scroll-component__outerdiv": {
        width: "100%",
      },
      "*::-webkit-scrollbar": {
        backgroundColor: "var(--scrollbar-color)",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "var(--scrollbar-thumb-color)",
      },
      fonts,
    })}
  />
);

export const AppThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  // TODO: Is this needed?
  useAccountSettings();

  return (
    <ComponentsThemeProvider legacyTheme={{}} enableDarkMode={true}>
      <GlobalStyles />
      {children}
    </ComponentsThemeProvider>
  );
};
